import { render, staticRenderFns } from "./myPorposalTable.vue?vue&type=template&id=7140ee48&"
import script from "./myPorposalTable.vue?vue&type=script&lang=ts&"
export * from "./myPorposalTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports